module.exports = __webpack_public_path__ + "img/user_tecnico.25f2e1eb.png";